import React, { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const WebsiteUserContext = createContext({
  websiteUser: false,
});

export const WebsiteUserProvider = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const location = useLocation();
  const [websiteUser, setWebsiteUser] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const source = searchParams.get('source');

    if (!isLoggedIn && source === 'website') {
      setWebsiteUser(true);
    } else {
      setWebsiteUser(false);
    }
  }, [isLoggedIn, location.search]);

  return (
    <WebsiteUserContext.Provider value={{ websiteUser }}>
      {children}
    </WebsiteUserContext.Provider>
  );
};

// ✅ Add this hook to make it easy to consume
export const useWebsiteUser = () => React.useContext(WebsiteUserContext);
